import React from "react";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import moment from "moment";
import {
    Chip,
    Checkbox,
    TextField,
    ListSubheader,
    Button,
    Grid,
    Typography,
    InputBase,
    Divider,
    Paper,
    Menu,
    MenuItem,
    CircularProgress,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon, KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faSyncAlt, faFilter, faClipboard } from "@fortawesome/pro-light-svg-icons";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import clsx from "clsx";
import { RequestAction, RequestTypes, RequestTypeNames } from '../../../Enums';
import SplitButton from "../../../../common/components/UI/SplitButton/SplitButton";
import ReactMultipleSelect from "../../../../common/components/UI/Select/MultipleReactSelect";
import { withTranslation } from "react-i18next";

import ReactSelect from "../../../../common/components/UI/Select/ReactSelect";
import ReactDateRangePicker from "../../../../common/components/UI/Datepicker/ReactDateRangePicker";
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { ConfirmDialog, DataviewFilterPanel } from "../../../App/components/core";
import ConfirmDialogContent from "../ConfirmDialogContent";
import { updateResetSearchQuery } from '../actions';
import { REQUEST_PAGE_DEFAULT_SELECTED_STATUS } from "../../../../EmploymentBillboard/constants.js";
import {
    getRequestTypeLabel,
} from '../../../Enums/Helpers/LabellingHelper';

import './managerTopBar.scss';

const MTB_CLASSES = {
    fullPage: 'mtb-full-page',
    topGrid: 'mtb-top-grid',
    ButtonAction: 'mtb-button-action',
    drpButton: 'mtb-drp-button',
    calendarIcon: 'mtb-calendar-icon',
    chevronIcon: 'mtb-chevron-icon',
    periodSelect: 'mtb-period-select',
    searchBar: 'mtb-search-bar',
    searchBarText: 'mtb-search-bar-text',
    divider: 'mtb-divider',
    moreOptionsContainer: 'mtb-more-options-container',
    moreOptionsBox: 'mtb-more-options-box',
    moreOptionsButton: 'mtb-more-options-button',
    iconFixHeight: 'mtb-icon-fix-height',
    labelButtons: 'mtb-label-buttons',
    buttonApply: 'mtb-button-apply',
    containerStylesContainer: 'mtb-container-styles-container',
    selectWrapper: 'mtb-select-wrapper',
    titleWrapper: 'mtb-title-wrapper',
    valueContainer: 'mtb-value-container',
    filtersRow: 'mtb-filters-row',
};

class ManagerTopBar extends React.Component {
    constructor(props) {
        super(props);
        this.theme = createTheme({
            palette: {
                primary: {
                    main: '#66b3ff',
                },
                secondary: {
                    main: '#66b3ff',
                },
            },
        });
        this.state = {
            openActionOptions: false,
            selectedActionIndex: 0,
            statusList: REQUEST_PAGE_DEFAULT_SELECTED_STATUS,
            shortTermSearch: this.props.currentQuery,
            textToUpdate: false,
            isConfirmDialogOpen: false,
            anchorEl: null,
            isReportDownloading: false,
            expandedGroups: [],
        }
    }

    static getDerivedStateFromProps(props) {
        if (props.resetSearchQuery) {
            props.updateResetSearchQuery(false)
            return {
                shortTermSearch: props.currentQuery
            }
        }

        return null;
    }

    handleActionType = (event, index) => {
        this.setState({
            selectedActionIndex: index,
            openActionOptions: false,
        })
    }

    handleActionRequest = (message) => {
        let actionEndpoints
        let successMessage
        switch (this.state.selectedActionIndex) {
            case RequestAction.Approve:
                actionEndpoints = {
                    toCover: 'manualApproveRequests',
                    shiftSwap: 'ManualApproveShiftSwap',
                    openShift: 'ApproveRequest',
                    vto: 'ApproveRequest',
                }
                successMessage = this.props.t('manager.approveSuccess')
                break;
            case RequestAction.Pending:
                actionEndpoints = {
                    toCover: 'manualPendingRequests',
                    shiftSwap: 'PendShiftSwap',
                    openShift: 'PendingRequest',
                    vto: 'PendingRequest',
                }
                successMessage = this.props.t('manager.pendingSuccess')
                break;
            case RequestAction.Refuse:
                actionEndpoints = {
                    toCover: 'manualRefuseRequests',
                    shiftSwap: 'refuseShiftSwapProposal',
                    openShift: 'RefuseRequest',
                    vto: 'RefuseRequest',
                }
                successMessage = this.props.t('manager.refuseSuccess')
                break;
            default:
                console.log('Action does not exist')
                return // Prevent further action if it does not exist
        }
        this.props.submitAction(actionEndpoints, message, successMessage)
    }

    handleActionOptionClick = () => {
        const selectedRequests = this.props.checkedRequests;

        if (selectedRequests.find(x => x.actionType === RequestTypes.voluntaryTimeOff && x.shifts.length === 0)) {
            this.props.handleSnackbar('error', this.props.t('manager.approveAtLeastOneShift'), true);
            return;
        }

        if (selectedRequests.length === 1
            && [RequestAction.Approve, RequestAction.Refuse].includes(this.state.selectedActionIndex)) {
            this.handleOpenConfirmDialog();
        } else {
            this.handleActionRequest();
        }
    }

    handleActionOptionToggle = () => {
        this.setState({
            openActionOptions: !this.state.openActionOptions
        })
    }

    handleActionOptionClose = () => {
        this.setState({
            openActionOptions: false
        })
    }

    handleClearFilters = () => {
        this.setState({
            shortTermSearch: "",
        });

        this.props.handleClearFilters();
    }

    handleSearch(target, value) {
        let { textToUpdate } = this.state;

        this.setState({
            shortTermSearch: value,
            textToUpdate: true
        }, () => {

            if (!textToUpdate) {
                setTimeout(() => {
                    this.setState({
                        textToUpdate: false
                    })
                    this.props.handleSearch(target, this.state.shortTermSearch);
                }, 250);
            }
        });
    }

    handleOpenConfirmDialog = () => {
        this.setState({ isConfirmDialogOpen: true })
    }

    handleCloseConfirmDialog = () => {
        this.setState({ isConfirmDialogOpen: false })
    }

    handleConfirm = (message) => {
        this.handleActionRequest(message)
        this.handleCloseConfirmDialog();
    }

    handleOpenReportOptions = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleCloseReportOptions = () => {
        this.setState({ anchorEl: null });
    };

    handleReportSelected = async (handleDownloadReport) => {
        this.setState({ anchorEl: null, isReportDownloading: true });
        await handleDownloadReport();
        this.setState({ isReportDownloading: false });
    };

    toggleGroupCollapse = (group) => {
        this.setState((prevState) => {
            const expandedGroups = [...prevState.expandedGroups];
            if (expandedGroups.includes(group)) {
                return { expandedGroups: expandedGroups.filter((g) => g !== group) };
            } else {
                expandedGroups.push(group);
                return { expandedGroups };
            }
        });
    };

    handleGroupCheckboxChange = (event, group) => {
        const isChecked = event.target.checked;
        const groupSettings = this.props.managerSettingsList.filter(
            (setting) => this.getGroupKey(setting) === group
        );

        const updatedSelectedSettings = isChecked
            ?  [
                ...this.props.selectedManagerSetting.filter(
                  (s) => !groupSettings.some((g) => g.aggregateRootId === s.aggregateRootId)
                ),
                ...groupSettings
              ]
            : this.props.selectedManagerSetting.filter(
                (selected) =>
                  !groupSettings.some(
                    (groupItem) => groupItem.aggregateRootId === selected.aggregateRootId
                  )
              );

        this.props.handleManagerSetting(undefined, updatedSelectedSettings);
    };

    isGroupFullySelected = (group) => {
        const groupSettings = this.props.managerSettingsList.filter(
            (setting) => this.getGroupKey(setting) === group
        );

        if (groupSettings.length === 0) return false;

        return groupSettings.every((groupSetting) =>
            this.props.selectedManagerSetting.some(
                (selected) => selected.aggregateRootId === groupSetting.aggregateRootId
            )
        );
    };

    getGroupLabel = (option) => {
        const groupKey = this.getGroupKey(option);
        return this.getGroupLabelFromKey(groupKey);
    };

    renderGroup = (params) => {
        const { expandedGroups } = this.state;

        const isExpanded = expandedGroups.includes(params.group);

        return (
            <li key={params.key}>
                <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                        onChange={(event) => this.handleGroupCheckboxChange(event, params.group)}
                        checked={this.isGroupFullySelected(params.group)}
                    />
                    <span>{this.getGroupLabelFromKey(params.group)}</span>
                    <Button
                        onClick={() => this.toggleGroupCollapse(params.group)}
                        style={{ marginLeft: 'auto' }}
                    >
                        {isExpanded ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                    </Button>
                </div>
                {isExpanded && <ul style={{ padding: 0 }}>{params.children}</ul>}
            </li>
        );
    };

    getGroupKey = (option) => {
        const { type } = option;
        const isSignUp = option.adminSettings[0]?.isSignUp;
      
        switch (type) {
          case RequestTypes.voluntaryTimeOff:
            return isSignUp
              ? 'VOLUNTARY_TIME_OFF_SIGN_UP'
              : 'VOLUNTARY_TIME_OFF_FILL';
          case RequestTypes.openShift:
            return isSignUp
              ? 'OPEN_SHIFT_SIGN_UP'
              : 'OPEN_SHIFT_FILL';
          default:
            return RequestTypeNames[type];
        }
      };

    getGroupLabelFromKey = (groupKey) => {
        const t = this.props.t;
        if (groupKey.startsWith('VOLUNTARY_TIME_OFF')) {
            const sub = groupKey.includes('SIGN_UP') ? 'signUp' : 'fill';
            return t(`requestType.requestSubtypes.voluntaryTimeOff.${sub}`);
        }

        if (groupKey.startsWith('OPEN_SHIFT')) {
            const sub = groupKey.includes('SIGN_UP') ? 'signUp' : 'fill';
            return t(`requestType.requestSubtypes.openShift.${sub}`);
        }

        if (groupKey === 'toCover') return t('requestType.toCover');
        if (groupKey === 'shiftSwap') return t('requestType.shiftSwap');

        return groupKey;
    };

    render() {
        const { isReportDownloading } = this.state;
        const { checkedRequests, disableApprove, disablePending, managerSettingsList, periodSelected, ranges, t, selectedManagerSetting, isShowDownloadExcelButton } = this.props;
        const classes = MTB_CLASSES;
        const disableAll = checkedRequests.length === 0;
        const actionOptions = this.props.actionOptions.map(x => {
            x.disabled = disableAll || (x.value === 'approve' && disableApprove) || (x.value === 'pending' && disablePending);
            return x
        });

        const { startDate, endDate } = periodSelected;

        const isPeriodSet = !!startDate && !!endDate;
        const [selectedRequest] = checkedRequests;
        const isVtoSignUp = selectedManagerSetting[0]?.type === 3 && selectedManagerSetting[0]?.adminSettings[0].isSignUp;

        const isOneOpenShiftRequestTypeSelected = selectedManagerSetting.length == 1 && selectedManagerSetting[0]?.type == 2

const groupedOptions = managerSettingsList.filter(x => x.visible)
    .sort((a, b) => {
        const keyA = this.getGroupKey(a);
        const keyB = this.getGroupKey(b);
        
        const orderMap = {
            'toCover': 1,
            'shiftSwap': 2,
            'OPEN_SHIFT_FILL': 3,
            'OPEN_SHIFT_SIGN_UP': 4,
            'VOLUNTARY_TIME_OFF_FILL': 5,
            'VOLUNTARY_TIME_OFF_SIGN_UP': 6
        };
        
        const orderA = orderMap[keyA];
        const orderB = orderMap[keyB];
        
        return orderA - orderB;
    });

        return (
            <React.Fragment>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={this.theme}>
                        <section>
                            <Grid container className={classes.fullPage} alignItems={'center'}>
                                <Grid item xs={12} lg={2} className={classes.topGrid}>
                                    <ReactSelect
                                        labelText={'Date category'}
                                        value={this.props.selectedSearchDateType}
                                        options={this.props.searchDateType}
                                        onChange={this.props.handleSelectSearchDateType}
                                        customStyles={{
                                            control: styles => ({
                                                ...styles,
                                                margin: 5,
                                                border: '1px solid #CCCCCC',
                                                padding: 3,
                                                height: 46,
                                            }),
                                            menu: styles => ({
                                                ...styles,
                                                zIndex: 100
                                            })
                                        }}
                                        selectWrapperClass={classes.selectWrapper}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={4} className={classes.topGrid}>
                                    <Typography component={'p'} className={classes.periodSelect}>Period</Typography>
                                    {
                                        isPeriodSet ? <ReactDateRangePicker
                                            ranges={ranges}
                                            startDate={moment.utc(startDate).toDate()}
                                            endDate={moment.utc(endDate).toDate()}
                                            onApply={this.props.handleEventDate}
                                            periodLabel={periodSelected.label}
                                            customRangeLabel={'Custom Range'}
                                            disableTranslations
                                        /> : <Button className={classes.drpButton} color="inherit">
                                            <div className={classes.valueContainer}>
                                                <FontAwesomeIcon className={classes.calendarIcon} icon={faCalendarAlt} />
                                                {periodSelected.label ? periodSelected.label : 'Current Schedule Period'}
                                            </div>
                                            <div className={clsx(classes.containerStylesContainer, "pull-right")}>
                                                <Divider className={classes.divider} orientation="vertical" />
                                            </div>
                                            <div className={clsx(classes.containerStylesContainer, "pull-right")}>
                                                <FontAwesomeIcon className={classes.chevronIcon} icon={faChevronDown} />
                                            </div>
                                        </Button>
                                    }

                                </Grid>
                                <Grid item xs={12} lg={4} className={classes.topGrid}>
                                    <ReactSelect
                                        labelText={t('manager.topbar.people')}
                                        value={this.props.selectedHyperfind}
                                        options={this.props.hyperFindQueries}
                                        onChange={this.props.handleSelectHyperfind}
                                        customStyles={{
                                            control: styles => ({
                                                ...styles,
                                                margin: 5,
                                                border: '1px solid #CCCCCC',
                                                padding: 3,
                                                height: 46,
                                            }),
                                            menu: styles => ({
                                                ...styles,
                                                zIndex: 100
                                            })
                                        }}
                                        selectWrapperClass={classes.selectWrapper}
                                        isLoading={this.props.isLoading}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems={'center'} className={classes.filtersRow} >
                                <Grid item xs={6} lg={2}>
                                    <SplitButton
                                        options={actionOptions}
                                        open={this.state.openActionOptions}
                                        selectedIndex={this.state.selectedActionIndex}
                                        size='full'
                                        color='primary'
                                        handleClick={this.handleActionOptionClick}
                                        handleMenuItemClick={this.handleActionType}
                                        handleToggle={this.handleActionOptionToggle}
                                        handleClose={this.handleActionOptionClose}
                                        className={classes.ButtonAction}
                                        placeholder={'Request Action'}
                                    />
                                </Grid>
                                <Grid item xs={5} lg={2}>
                                    <Autocomplete
                                        id="grouped-demo"
                                        disableCloseOnSelect
                                        multiple
                                        value={selectedManagerSetting}
                                        onChange={this.props.handleManagerSetting}
                                        options={groupedOptions}
                                        getOptionLabel={(option) => option.name}
                                        renderGroup={this.renderGroup}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props} key={option.aggregateRootId}>
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    checked={selected}
                                                    color="primary"
                                                />
                                                {option.name}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="medium"
                                                variant="outlined"
                                                label={'All requests'}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        flexWrap: 'nowrap',
                                                        maxHeight: 56,
                                                        overflow: 'hidden',
                                                    },
                                                }}
                                            />
                                        )}
                                        renderTags={(tagValue, getTagProps) => {
                                            if (tagValue.length === 0) return [];

                                            const maxWidth = 300;
                                            let currentWidth = 0;
                                            const visibleTags = [];
                                            const averageCharWidth = 8;

                                            for (let i = 0; i < tagValue.length; i++) {
                                                const tagWidth = tagValue[i].name.length * averageCharWidth;
                                                const wouldOverflow = currentWidth + tagWidth > maxWidth - 55;

                                                if (wouldOverflow && i > 0) {
                                                    const remaining = tagValue.length - i;
                                                    visibleTags.push(
                                                        <Chip
                                                            key="overflow"
                                                            label={`+${remaining}`}
                                                            size="small"
                                                            variant="outlined"
                                                            color="primary"
                                                        />
                                                    );
                                                    break;
                                                }

                                                visibleTags.push(
                                                    <Chip
                                                        {...getTagProps({ index: i })}
                                                        key={tagValue[i].aggregateRootId}
                                                        label={tagValue[i].name}
                                                        size="small"
                                                    />
                                                );

                                                currentWidth += tagWidth + 8;
                                            }

                                            return visibleTags;
                                        }}
                                        groupBy={(option) => this.getGroupKey(option)}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <ReactMultipleSelect
                                        labelText={'Status'}
                                        value={this.props.selectedStatus}
                                        onChange={this.props.handleStatus}
                                        optionsList={this.state.statusList}
                                        valueStateName={this.props.selectedStatusStateName}
                                        defaultCheckedAll={true}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <Paper component="form" className={classes.searchBar}>
                                        <InputBase
                                            name="searchQuery"
                                            onChange={(event) => {
                                                this.handleSearch(event.target, event.target.value)
                                            }}
                                            onKeyPress={(ev) => { //this prevents auto submit when pressing enter
                                                if (ev.key === 'Enter') {
                                                    // Do nothing
                                                    ev.preventDefault();
                                                }
                                            }}

                                            className={classes.searchBarText}
                                            placeholder="Search"
                                            value={this.state.shortTermSearch}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <Button className={classes.buttonApply} onClick={() => this.props.refreshAllData()}>
                                        <div>
                                            <Typography className={classes.labelButtons}>Apply filters<FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faFilter} /></Typography>
                                        </div>
                                    </Button>
                                </Grid>
                                <div className={classes.moreOptionsContainer}>
                                    <div className={classes.moreOptionsBox}>
                                        {isShowDownloadExcelButton ? (
                                            <CustomToolTip
                                                titleText={t('manager.topbar.downloadToExcel')}
                                                jsx={
                                                    <>
                                                        <Button onClick={this.handleOpenReportOptions} className={classes.moreOptionsButton} aria-label="more">
                                                            {isReportDownloading
                                                                ? <CircularProgress size={24} />
                                                                : <FontAwesomeIcon className={classes.iconFixHeight} icon={faClipboard} />}
                                                        </Button>
                                                        <Menu
                                                            id="download-menu"
                                                            anchorEl={this.state.anchorEl}
                                                            open={Boolean(this.state.anchorEl)}
                                                            onClose={this.handleCloseReportOptions}
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'left',
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'left',
                                                            }}
                                                        >
                                                            <MenuItem onClick={() => this.handleReportSelected(this.props.downloadDataAsExcel)}>{t("manager.topbar.requestDashboardReport")}</MenuItem>
                                                            {isOneOpenShiftRequestTypeSelected &&
                                                                <MenuItem onClick={() => this.handleReportSelected(this.props.downloadOpenShiftReportAsExcel)}>{t("manager.topbar.openShiftsReport")}</MenuItem>
                                                            }
                                                        </Menu>
                                                    </>
                                                }
                                            />
                                        ) : null}
                                        {this.props.dataviewButton && isVtoSignUp ?
                                            <CustomToolTip
                                                titleText={t('manager.topbar.runAwardingRunes')}
                                                jsx={
                                                    <Button disabled={!selectedManagerSetting[0].adminSettings[0].awardingRuleEnabled} onClick={() => this.props.handleRecalculateAwarding('VTO')} className={classes.moreOptionsButton} aria-label="more">
                                                        <FontAwesomeIcon className={classes.iconFixHeight} icon={faSyncAlt} />
                                                    </Button>
                                                }
                                            />
                                            : null}

                                        {this.props.dataviewButton ?
                                            <DataviewFilterPanel
                                                classes={classes}
                                                handleFilterDataview={this.props.handleFilterDataview}
                                                managerSetting={this.props.managerSetting}
                                                handleChangeDataview={this.props.handleChangeDataview}
                                                dataviewsList={this.props.dataviewsList}
                                            />
                                            : null
                                        }
                                    </div>
                                </div>
                            </Grid>
                        </section>
                    </ThemeProvider >
                </StyledEngineProvider>
                <ConfirmDialog
                    open={this.state.isConfirmDialogOpen}
                    onCancel={this.handleCloseConfirmDialog}
                    onConfirm={this.handleConfirm}
                >
                    <ConfirmDialogContent request={selectedRequest} />
                </ConfirmDialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentQuery: state.searchQuery,
        data: state.data,
        hyperFindQueries: state.hyperFindQueries,
        managerSettingsList: state.managerSettingsList,
        periodSelected: state.periodSelected,
        ranges: state.ranges,
        resetSearchQuery: state.resetSearchQuery,
        searchDateType: state.searchDateType,
        selectedHyperfind: state.selectedHyperfind,
        selectedManagerSetting: state.selectedManagerSetting,
        selectedSearchDateType: state.selectedSearchDateType,
        selectedStatus: state.selectedStatus,
    }
}

export default connect(mapStateToProps, { updateResetSearchQuery })(withTranslation('employmentBillboard')(ManagerTopBar));